 
// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { type FormikProps } from 'formik';
// import { useTranslation } from 'react-i18next';
// import { Form } from 'react-bootstrap';
// import Loading from '@components/Shared/Loader/Loading';
// import { NumericFormat } from 'react-number-format';

// // ✅ Picker (Hook + Stable Modal)
// import { useItemUomPicker, ItemUomPickerModal } from '@pages/INV/lookups/useItemUomPicker';

// // ✅ API (لجلب تفاصيل العرض وقت التعديل)
// import { fetchItemsWithUomLookup, type ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';

// interface LinesProps {
//   formik: FormikProps<any>;
//   isUpdate?: boolean;
//   maxTableHeight?: string;
// }

// type ItemType = 'InventoryItem' | 'ExpenseItem' | 'FixedAssetItem' | 'ServiceItem' | 'UndefinedItem';

// const EACH_UOM_ID = 'c0391001-ffc5-4a91-9470-cb9e8ac2a650'; // Each
// const DEFAULT_ITEM_TYPE: ItemType = 'InventoryItem';

// const chunk = <T,>(arr: T[], size: number) => {
//   const out: T[][] = [];
//   for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
//   return out;
// };

// const PRLines: React.FC<LinesProps> = ({ formik, isUpdate = false, maxTableHeight = '500px' }) => {
//   const { values } = formik;
//   const { i18n, t } = useTranslation();

//   const inventoryId: string | null = values?.inventoryId ?? null;

//   // ✅ Picker
//   const { pickItemUom, modalProps } = useItemUomPicker();

//   // ✅ Map لعرض أسماء الأصناف والوحدات في وضع التعديل
//   const [detailsMap, setDetailsMap] = useState<Map<string, ItemWithUomRow>>(new Map());
//   const [detailsLoading, setDetailsLoading] = useState(false);

//   // ✅ Abort لجلب التفاصيل (وقت التعديل)
//   const abortRef = useRef<AbortController | null>(null);

//   // =========================
//   // ✅ Reset lines on category change (نفس سلوكك)
//   // =========================
//   useEffect(() => {
//     if (!isUpdate) {
//       formik?.setFieldValue('transactionsLinesList', [
//         {
//           itemType: DEFAULT_ITEM_TYPE,
//           itemId: null,
//           lineNumber: 1,
//           uom: '',
//           qty: 0,
//           description: '',
//           id: null,
//           inventoryId: inventoryId ?? ''
//         }
//       ]);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [formik.values.categoryId]);

//   // =========================
//   // Helpers
//   // =========================
//   const lineHasDuplicateItemUom = (itemId: any, uom: any, excludeIndex: number) => {
//     if (!itemId || !uom) return false;
//     return (values.transactionsLinesList || []).some((l: any, i: number) => {
//       if (i === excludeIndex) return false;
//       return String(l?.itemId || '') === String(itemId) && String(l?.uom || '') === String(uom || '');
//     });
//   };

//   const resetLineBase = (line: any) => ({
//     ...line,
//     itemId: null,
//     description: '',
//     uom: '',
//     qty: 0
//   });

//   const getInfo = (line: any) => {
//     if (!line?.itemId || !line?.uom) return null;
//     return detailsMap.get(`${line.itemId}|${line.uom}`) || null;
//   };

//   const getItemNameForLine = (line: any) => {
//     const info = getInfo(line);
//     const isEn = i18n.language === 'en';
//     const name = isEn ? info?.name || info?.name2 : info?.name2 || info?.name;
//     return name || line?.description || '';
//   };

//   const getUomNameForLine = (line: any) => {
//     const info = getInfo(line);
//     const isEn = i18n.language === 'en';
//     const uomName = isEn
//       ? info?.unitOfMeasureName || info?.unitOfMeasureName2
//       : info?.unitOfMeasureName2 || info?.unitOfMeasureName;
//     return uomName || '';
//   };

//   // =========================
//   // ✅ Build a key that changes only when (itemType,itemId,uom) changes
//   // =========================
//   const linesKey = useMemo(() => {
//     const lines = values.transactionsLinesList || [];
//     return lines.map((l: any) => `${l?.itemType || ''}:${l?.itemId || ''}:${l?.uom || ''}`).join('|');
//   }, [values.transactionsLinesList]);

//   // =========================
//   // ✅ Load item/uom details in UPDATE mode (GetById)
//   // =========================
//   useEffect(() => {
//     const run = async () => {
//       if (!isUpdate) return;
//       if (!inventoryId) return;

//       const lines = values.transactionsLinesList || [];
//       const valid = lines.filter((l: any) => l?.itemType !== 'UndefinedItem' && l?.itemId && l?.uom);

//       if (!valid.length) return;

//       // ✅ احسب المفقود فقط (حتى لا نعيد نداء السيرفر مع تغيير qty)
//       const missingByType = new Map<string, Set<string>>();
//       for (const l of valid) {
//         const key = `${l.itemId}|${l.uom}`;
//         if (detailsMap.has(key)) continue;

//         const type = String(l.itemType || DEFAULT_ITEM_TYPE);
//         if (!missingByType.has(type)) missingByType.set(type, new Set());
//         missingByType.get(type)!.add(String(l.itemId));
//       }

//       if (missingByType.size === 0) return;

//       // abort previous
//       abortRef.current?.abort();
//       abortRef.current = new AbortController();

//       setDetailsLoading(true);
//       try {
//         const merged = new Map(detailsMap);

//         for (const [type, idsSet] of missingByType.entries()) {
//           const itemIds = Array.from(idsSet);

//           for (const idsChunk of chunk(itemIds, 200)) {
//             const resp = await fetchItemsWithUomLookup(
//               {
//                 InventoryId: inventoryId,
//                 Scope: 1
//                 // ✅ في التعديل نسمح بإظهار الأصناف حتى لو Disabled
//                 // OnlyEnabled: false,
//                 // WithLots: false
//               },
//               {
//                 pageIndex: 1,
//                 // pageSize: 5000,
//                 pageSize: 3000,
//                 itemType: type,
//                 itemIds: idsChunk
//               },
//               abortRef.current.signal
//             );

//             for (const r of resp.data.data || []) {
//               merged.set(`${r.itemId}|${r.unitOfMeasure}`, r);
//             }
//           }
//         }

//         setDetailsMap(merged);
//       } catch (e: any) {
//         if (e?.name !== 'CanceledError') console.error(e);
//       } finally {
//         setDetailsLoading(false);
//       }
//     };

//     run();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isUpdate, inventoryId, linesKey]);

//   // ✅ clear details when inventory changes
//   useEffect(() => {
//     setDetailsMap(new Map());
//   }, [inventoryId]);

//   // =========================
//   // Line change
//   // =========================
//   const handleLineChange = (index: number, field: string, value: any) => {
//     const updatedLines = [...(values.transactionsLinesList || [])];
//     if (!updatedLines[index]) return;

//     const currentLine = { ...updatedLines[index] };
//     const currentItemType: ItemType = (currentLine.itemType || DEFAULT_ITEM_TYPE) as ItemType;

//     // ✅ itemType
//     if (field === 'itemType') {
//       const nextType = (value || DEFAULT_ITEM_TYPE) as ItemType;

//       if (nextType === 'UndefinedItem') {
//         updatedLines[index] = {
//           ...resetLineBase(currentLine),
//           itemType: nextType,
//           uom: EACH_UOM_ID
//         };
//       } else {
//         updatedLines[index] = {
//           ...resetLineBase(currentLine),
//           itemType: nextType
//         };
//       }

//       formik.setFieldValue('transactionsLinesList', updatedLines);
//       return;
//     }

//     // ✅ clear item
//     if (field === 'clearItem') {
//       const newLine = {
//         ...resetLineBase(currentLine),
//         itemType: currentItemType
//       };
//       if (currentItemType === 'UndefinedItem') newLine.uom = EACH_UOM_ID;

//       updatedLines[index] = newLine;
//       formik.setFieldValue('transactionsLinesList', updatedLines);
//       return;
//     }

//     updatedLines[index] = { ...currentLine, [field]: value };
//     formik.setFieldValue('transactionsLinesList', updatedLines);
//   };

//   // =========================
//   // Add / Delete
//   // =========================
//   const handleAddLine = () => {
//     const newLine = {
//       itemType: DEFAULT_ITEM_TYPE,
//       itemId: null,
//       lineNumber: (values.transactionsLinesList?.length || 0) + 1,
//       uom: '',
//       qty: 0,
//       description: '',
//       id: null,
//       inventoryId: inventoryId ?? ''
//     };

//     formik.setFieldValue('transactionsLinesList', [...(formik.values.transactionsLinesList || []), newLine]);
//   };

//   const handleDeleteLine = (index: number) => {
//     const updatedLines = (values.transactionsLinesList || []).filter((_: any, i: number) => i !== index);
//     formik?.setFieldValue('transactionsLinesList', updatedLines);
//   };

//   // =========================
//   // ✅ Open picker for line (select item + uom)
//   // =========================
//   const openPickerForLine = async (lineIndex: number) => {
//     const lines = values.transactionsLinesList || [];
//     const line = lines[lineIndex];
//     if (!line) return;

//     const itemType: ItemType = (line.itemType || DEFAULT_ITEM_TYPE) as ItemType;

//     if (!inventoryId) {
//       window?.alert?.(t('يجب اختيار المخزن أولاً.'));
//       return;
//     }

//     if (itemType === 'UndefinedItem') return;

//     const picked = await pickItemUom({
//       title: i18n.language === 'en' ? 'Pick Item & UOM' : 'اختيار صنف ووحدة',
//       params: {
//         InventoryId: inventoryId,
//         Scope: 1
//         // OnlyEnabled: true,
//         // WithLots: false
//       },
//       bodyDefaults: {
//         categoryId: values.categoryId ?? undefined,
//         itemType: itemType
//         // purchasingEnabledFlag: true
//       },
//       pageSize: 10,
//       searchMode: 'manual',
//       // searchMode: 'auto',

//       initialSearchField: 'barcode',
//       isDisabledRow: (r: any) => lineHasDuplicateItemUom(r.itemId, r.unitOfMeasure, lineIndex)
//     });

//     if (!picked) return;

//     const row: any = picked.row;

//     // ✅ منع التكرار
//     if (lineHasDuplicateItemUom(row.itemId, row.unitOfMeasure, lineIndex)) {
//       window?.alert?.(t('لا يمكن تكرار نفس الصنف بنفس الوحدة.'));
//       return;
//     }

//     // ✅ خزّن للعرض فوراً بدون انتظار fetch
//     setDetailsMap(prev => {
//       const m = new Map(prev);
//       m.set(`${row.itemId}|${row.unitOfMeasure}`, row);
//       return m;
//     });

//     // ✅ حدّث السطر
//     const isEn = i18n.language === 'en';
//     const desc = isEn ? row.name || row.name2 || '' : row.name2 || row.name || '';

//     const updatedLines = [...lines];
//     const currentLine = { ...updatedLines[lineIndex] };

//     updatedLines[lineIndex] = {
//       ...currentLine,
//       itemType,
//       itemId: row.itemId,
//       uom: row.unitOfMeasure,
//       description: desc
//     };

//     formik.setFieldValue('transactionsLinesList', updatedLines);
//   };

//   // =========================
//   // Totals
//   // =========================
//   const totals = useMemo(() => {
//     const qtyTotal = (values.transactionsLinesList || []).reduce((sum: number, l: any) => sum + Number(l.qty || 0), 0);
//     return { qtyTotal };
//   }, [values.transactionsLinesList]);

//   // =========================
//   // UI
//   // =========================
//   return (
//     <Loading loading={false} error={null} Type='Dots'>
//       {/* ✅ one time modal */}
//       <ItemUomPickerModal {...modalProps} />

//       <div className=' '>
//         <div className='card-header d-flex justify-content-between align-items-center'>
//           <h6 className='mb-0'>
//             <i className='fas fa-clipboard-list me-2'></i>
//             {t('بنود طلب الشراء')}
//           </h6>

//           <div className='d-flex align-items-center gap-2'>
//             {detailsLoading && isUpdate && (
//               <span className='badge bg-warning text-dark'>
//                 {i18n.language === 'en' ? 'Loading item details...' : 'جاري تحميل تفاصيل الأصناف...'}
//               </span>
//             )}

//             <span className='badge bg-theme me-2'>عدد البنود: {values.transactionsLinesList?.length || 0}</span>

//             <button type='button' className='btn btn-theme btn-sm' onClick={handleAddLine}>
//               <i className='fas fa-plus me-2'></i>
//               {t('إضافة بند جديد')}
//             </button>
//           </div>
//         </div>

//         <div className='card-body p-3'>
//           <div className='bg-inverse bg-opacity-10 p-3 rounded-0'>
//             <div className='d-flex flex-wrap gap-4 justify-content-between'>
//               <div className='d-flex gap-2 align-items-center'>
//                 <span className='fw-bold'>{t('عدد البنود')}:</span>
//                 <span className='fw-bold'>{values.transactionsLinesList?.length || 0}</span>
//               </div>
//               <div className='d-flex gap-2 align-items-center'>
//                 <span className='fw-bold'>{t('إجمالي الكمية')}:</span>
//                 <span className='fw-bold text-warning'>{totals.qtyTotal}</span>
//               </div>
//               <div className='d-flex gap-2 align-items-center'>
//                 <span className='fw-bold'>{t('المخزن')}:</span>
//                 <span className='text-theme fw-bold'>{inventoryId ? t('محدد') : t('غير محدد')}</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className='card-body p-0'>
//           <div
//             className='table-responsive'
//             style={{ maxHeight: maxTableHeight, overflow: 'auto', position: 'relative' }}
//           >
//             <table className='table table-hover mb-0' style={{ minWidth: '1100px' }}>
//               <thead
//                 className='table-actived fw-bold'
//                 style={{
//                   position: 'sticky',
//                   top: 0,
//                   zIndex: 100,
//                   backgroundColor: 'var(--bs-table-bg)',
//                   backdropFilter: 'blur(30px)',
//                   boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                 }}
//               >
//                 <tr>
//                   <th
//                     className='text-center small'
//                     style={{
//                       width: '50px',
//                       minWidth: '50px',
//                       position: 'sticky',
//                       left: 0,
//                       backgroundColor: 'var(--bs-table-bg)',
//                       zIndex: 101,
//                       boxShadow: '2px 0 4px rgba(0,0,0,0.1)'
//                     }}
//                   >
//                     #
//                   </th>

//                   <th className='text-center small' style={{ width: '200px', minWidth: '200px' }}>
//                     {t('نوع الصنف')}
//                   </th>

//                   {/* ✅ merged: Item + UOM + Barcode */}
//                   <th className='text-center small' style={{ width: '720px', minWidth: '720px' }}>
//                     {t('الصنف / الوحدة / الباركود')}
//                   </th>

//                   <th className='text-center small' style={{ width: '140px', minWidth: '140px' }}>
//                     {t('الكمية')}
//                   </th>

//                   <th className='text-center small' style={{ width: '60px', minWidth: '60px' }}></th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {(values.transactionsLinesList || []).length > 0 ? (
//                   (values.transactionsLinesList || []).map((line: any, index: number) => {
//                     const itemType: ItemType = (line.itemType || DEFAULT_ITEM_TYPE) as ItemType;

//                     const isDuplicate =
//                       itemType !== 'UndefinedItem' &&
//                       line.itemId &&
//                       line.uom &&
//                       (values.transactionsLinesList || []).some(
//                         (l: any, i: number) =>
//                           i !== index &&
//                           String(l?.itemId || '') === String(line.itemId) &&
//                           String(l?.uom || '') === String(line.uom || '')
//                       );

//                     const disablePick = !inventoryId || itemType === 'UndefinedItem';

//                     const info = getInfo(line);
//                     const itemName = itemType === 'UndefinedItem' ? '' : getItemNameForLine(line);
//                     const uomName =
//                       itemType === 'UndefinedItem'
//                         ? i18n.language === 'en'
//                           ? 'Each'
//                           : 'حبة'
//                         : getUomNameForLine(line) || '';

//                     const barcode = info?.barcode || '';

//                     const uomDisplay =
//                       itemType === 'UndefinedItem'
//                         ? i18n.language === 'en'
//                           ? 'Each'
//                           : 'حبة'
//                         : uomName ||
//                           (detailsLoading
//                             ? i18n.language === 'en'
//                               ? 'Loading...'
//                               : '...جاري التحميل'
//                             : line.uom
//                             ? `ID: ${line.uom}`
//                             : '-');

//                     const barcodeDisplay =
//                       itemType === 'UndefinedItem'
//                         ? '-'
//                         : barcode ||
//                           (detailsLoading ? (i18n.language === 'en' ? 'Loading...' : '...جاري التحميل') : '-');

//                     return (
//                       <tr key={index}>
//                         <td className='text-center align-middle bg-body shadow' style={{ position: 'sticky', left: 0 }}>
//                           <span className='badge bg-theme bg-opacity-80 fw-bold' style={{ fontSize: '0.85rem' }}>
//                             {index + 1}
//                           </span>
//                         </td>

//                         {/* ✅ نوع الصنف */}
//                         <td className='align-middle'>
//                           <select
//                             className='form-select form-select-sm border-theme bg-body'
//                             value={itemType || ''}
//                             onChange={e => handleLineChange(index, 'itemType', e.target.value)}
//                             style={{ width: '100%' }}
//                             disabled={isUpdate && !!line.id}
//                           >
//                             <option value='InventoryItem'>{i18n.language === 'en' ? 'Inventory' : 'مخزني'}</option>
//                             <option value='FixedAssetItem'>{i18n.language === 'en' ? 'Fixed Asset' : 'أصل'}</option>
//                             <option value='ServiceItem'>{i18n.language === 'en' ? 'Service' : 'خدمي'}</option>
//                             <option value='UndefinedItem'>
//                               {i18n.language === 'en' ? 'Undefined Item' : 'صنف غير معرف'}
//                             </option>
//                           </select>
//                         </td>

//                         {/* ✅ merged cell: item + uom + barcode */}
//                         <td className='align-middle'>
//                           <div style={{ width: '100%' }}>
//                             {itemType === 'UndefinedItem' ? (
//                               <div className='p-2 border border-theme bg-body'>
//                                 <Form.Control
//                                   className='form-control form-control-sm border-theme'
//                                   as='textarea'
//                                   rows={1}
//                                   value={line.description || ''}
//                                   onChange={e => handleLineChange(index, 'description', e.target.value)}
//                                   style={{ overflow: 'hidden', height: 'auto' }}
//                                   placeholder={i18n.language === 'en' ? 'Enter description...' : 'اكتب وصف الصنف...'}
//                                 />

//                                 <small className='text-muted d-block mt-2'>
//                                   {t('الوحدة')}: <span className='fw-bold text-theme'>{uomDisplay}</span>
//                                   <span className='mx-2'>•</span>
//                                   {t('باركود')}: <span className='fw-bold'>{barcodeDisplay}</span>
//                                 </small>
//                               </div>
//                             ) : (
//                               <div className={`p-2 border ${isDuplicate ? 'border-danger' : 'border-theme'} bg-body`}>
//                                 <div className='d-flex align-items-start gap-2'>
//                                   <div className='flex-grow-1' style={{ minWidth: 0 }}>
//                                     {line.itemId ? (
//                                       <>
//                                         <span className='fw-bold text-truncate d-block'>
//                                           {itemName ||
//                                             (detailsLoading
//                                               ? i18n.language === 'en'
//                                                 ? 'Loading...'
//                                                 : '...جاري التحميل'
//                                               : `ID: ${line.itemId}`)}
//                                         </span>

//                                         <small className='text-muted d-block'>
//                                           {t('الوحدة')}: <span className='fw-bold text-theme'>{uomDisplay}</span>
//                                           <span className='mx-2'>•</span>
//                                           {t('باركود')}: <span className='fw-bold'>{barcodeDisplay}</span>
//                                         </small>
//                                       </>
//                                     ) : (
//                                       <span className='text-muted'>{t('اختر الصنف')}</span>
//                                     )}
//                                   </div>

//                                   <button
//                                     type='button'
//                                     className='btn btn-sm btn-theme rounded-0'
//                                     onClick={() => openPickerForLine(index)}
//                                     disabled={disablePick}
//                                     title={
//                                       !inventoryId
//                                         ? t('يجب اختيار المخزن أولاً.')
//                                         : itemType === 'UndefinedItem'
//                                         ? t('غير متاح للصنف غير المعرف')
//                                         : t('اختيار صنف ووحدة')
//                                     }
//                                   >
//                                     <i className='fas fa-search me-1'></i>
//                                     {line.itemId ? t('تغيير') : t('اختيار')}
//                                   </button>

//                                   {line.itemId && (
//                                     <button
//                                       type='button'
//                                       className='btn btn-sm btn-outline-danger rounded-0'
//                                       onClick={() => handleLineChange(index, 'clearItem', true)}
//                                       title={t('مسح الصنف')}
//                                       disabled={isUpdate && !!line.id}
//                                     >
//                                       <i className='fas fa-times'></i>
//                                     </button>
//                                   )}
//                                 </div>

//                                 {isDuplicate && (
//                                   <small className='text-danger d-block mt-1'>
//                                     <i className='fas fa-exclamation-triangle me-1'></i>
//                                     {t('هذا الصنف مكرر مع نفس الوحدة')}
//                                   </small>
//                                 )}
//                               </div>
//                             )}
//                           </div>
//                         </td>

//                         {/* ✅ الكمية */}
//                         <td className='align-middle'>
//                           <NumericFormat
//                             name={`line-${index}-qty`}
//                             value={line.qty}
//                             thousandSeparator=','
//                             decimalSeparator='.'
//                             decimalScale={0}
//                             allowNegative={false}
//                             className='form-control form-control-sm border-theme text-center bg-body'
//                             onValueChange={v => handleLineChange(index, 'qty', v.floatValue ?? 0)}
//                             disabled={itemType !== 'UndefinedItem' && !line.itemId}
//                             style={{ width: '100%' }}
//                           />
//                         </td>

//                         {/* ✅ Delete */}
//                         <td className='align-middle text-center'>
//                           <button
//                             type='button'
//                             className='btn btn-sm btn-danger rounded-0'
//                             onClick={() => handleDeleteLine(index)}
//                             title={t('Delete Line')}
//                             style={{ width: '28px', height: '28px', padding: '0' }}
//                             // disabled={isUpdate && !!line.id}
//                             // disabled={ !!line.id}
//                           >
//                             <i className='fas fa-trash text-white'></i>
//                           </button>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan={5} className='text-center py-4 text-muted'>
//                       <i className='fa fa-inbox fa-2x mb-2'></i>
//                       <br />
//                       {t('لا توجد بنود مضافة')}
//                       <br />
//                       <button type='button' className='btn btn-theme mt-3' onClick={handleAddLine}>
//                         <i className='fas fa-plus me-2'></i>
//                         {t('إضافة أول بند')}
//                       </button>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         <div className='card-footer d-flex justify-content-between align-items-center'>
//           <div className='text-muted small'>
//             <i className='fas fa-list me-1'></i>
//             عرض {(values.transactionsLinesList || []).length} من {(values.transactionsLinesList || []).length} بند
//           </div>
//           <div className='text-theme fw-bold'>
//             <i className='fas fa-calculator me-2'></i>
//             {t('إجمالي الكمية')}: {totals.qtyTotal}
//           </div>
//         </div>
//       </div>
//     </Loading>
//   );
// };

// export default PRLines;


import React, { useEffect, useMemo, useRef, useState } from 'react';
import { type FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import Loading from '@components/Shared/Loader/Loading';
import { NumericFormat } from 'react-number-format';

// ✅ Picker (Hook + Stable Modal)
import { useItemUomPicker, ItemUomPickerModal } from '@pages/INV/lookups/useItemUomPicker';

// ✅ API (لجلب تفاصيل العرض + جلب جميع وحدات الصنف)
import { fetchItemsWithUomLookup, type ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';

interface LinesProps {
  formik: FormikProps<any>;
  isUpdate?: boolean;
  maxTableHeight?: string;
}

type ItemType = 'InventoryItem' | 'ExpenseItem' | 'FixedAssetItem' | 'ServiceItem' | 'UndefinedItem';

const EACH_UOM_ID = 'c0391001-ffc5-4a91-9470-cb9e8ac2a650'; // Each
const DEFAULT_ITEM_TYPE: ItemType = 'InventoryItem';

const chunk = <T,>(arr: T[], size: number) => {
  const out: T[][] = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
};

const PRLines: React.FC<LinesProps> = ({ formik, isUpdate = false, maxTableHeight = '500px' }) => {
  const { values } = formik;
  const { i18n, t } = useTranslation();

  const inventoryId: string | null = values?.inventoryId ?? null;

  // ✅ Picker
  const { pickItemUom, modalProps } = useItemUomPicker();

  // ✅ Map لعرض أسماء الأصناف والوحدات + باركود (ويدعم التعديل)
  const [detailsMap, setDetailsMap] = useState<Map<string, ItemWithUomRow>>(new Map());
  const [detailsLoading, setDetailsLoading] = useState(false);

  // ✅ Abort لجلب التفاصيل (update-mode + uoms preload)
  const abortRef = useRef<AbortController | null>(null);

  // =========================
  // ✅ Barcode Scan (quick add)
  // =========================
  const barcodeInputRef = useRef<HTMLInputElement | null>(null);
  const barcodeAbortRef = useRef<AbortController | null>(null);
  const [barcodeTerm, setBarcodeTerm] = useState('');
  const [barcodeLoading, setBarcodeLoading] = useState(false);
  const [barcodeError, setBarcodeError] = useState<string | null>(null);

  // =========================
  // Helpers
  // =========================
  const lineHasDuplicateItemUom = (itemId: any, uom: any, excludeIndex: number) => {
    if (!itemId || !uom) return false;
    return (values.transactionsLinesList || []).some((l: any, i: number) => {
      if (i === excludeIndex) return false;
      return String(l?.itemId || '') === String(itemId) && String(l?.uom || '') === String(uom || '');
    });
  };

  const resetLineBase = (line: any) => ({
    ...line,
    itemId: null,
    description: '',
    uom: '',
    qty: 1
  });

  const getInfo = (line: any) => {
    if (!line?.itemId || !line?.uom) return null;
    return detailsMap.get(`${line.itemId}|${line.uom}`) || null;
  };

  const getItemNameForLine = (line: any) => {
    const info = getInfo(line);
    const isEn = i18n.language === 'en';
    const name = isEn ? info?.name || info?.name2 : info?.name2 || info?.name;
    return name || line?.description || '';
  };

  const getUomNameForLine = (line: any) => {
    const info = getInfo(line);
    const isEn = i18n.language === 'en';
    const uomName = isEn
      ? info?.unitOfMeasureName || info?.unitOfMeasureName2
      : info?.unitOfMeasureName2 || info?.unitOfMeasureName;
    return uomName || '';
  };

  // =========================
  // ✅ Reset lines on category change (نفس سلوكك)
  // =========================
  useEffect(() => {
    if (!isUpdate) {
      formik?.setFieldValue('transactionsLinesList', [
        {
          itemType: DEFAULT_ITEM_TYPE,
          itemId: null,
          lineNumber: 1,
          uom: '',
          qty: 1,
          description: '',
          id: null,
          inventoryId: inventoryId ?? ''
        }
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.categoryId]);

  // =========================
  // ✅ linesKey: يتغير فقط عند (itemType,itemId,uom)
  // =========================
  const linesKey = useMemo(() => {
    const lines = values.transactionsLinesList || [];
    return lines.map((l: any) => `${l?.itemType || ''}:${l?.itemId || ''}:${l?.uom || ''}`).join('|');
  }, [values.transactionsLinesList]);

  // =========================
  // ✅ Update-mode: load missing details (names/barcodes/uoms)
  // =========================
  useEffect(() => {
    const run = async () => {
      if (!isUpdate) return;
      if (!inventoryId) return;

      const lines = values.transactionsLinesList || [];
      const valid = lines.filter((l: any) => l?.itemType !== 'UndefinedItem' && l?.itemId && l?.uom);

      if (!valid.length) return;

      const missingByType = new Map<string, Set<string>>();
      for (const l of valid) {
        const key = `${l.itemId}|${l.uom}`;
        if (detailsMap.has(key)) continue;

        const type = String(l.itemType || DEFAULT_ITEM_TYPE);
        if (!missingByType.has(type)) missingByType.set(type, new Set());
        missingByType.get(type)!.add(String(l.itemId));
      }

      if (missingByType.size === 0) return;

      abortRef.current?.abort();
      abortRef.current = new AbortController();

      setDetailsLoading(true);
      try {
        const merged = new Map(detailsMap);

        for (const [type, idsSet] of missingByType.entries()) {
          const itemIds = Array.from(idsSet);

          for (const idsChunk of chunk(itemIds, 200)) {
            const resp = await fetchItemsWithUomLookup(
              {
                InventoryId: inventoryId,
                Scope: 1
              },
              {
                pageIndex: 1,
                pageSize: 3000,
                itemType: type,
                itemIds: idsChunk
              },
              abortRef.current.signal
            );

            for (const r of resp.data?.data || []) {
              merged.set(`${r.itemId}|${r.unitOfMeasure}`, r);
            }
          }
        }

        setDetailsMap(merged);
      } catch (e: any) {
        if (e?.name !== 'CanceledError') console.error(e);
      } finally {
        setDetailsLoading(false);
      }
    };

    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdate, inventoryId, linesKey]);

  // ✅ clear details when inventory changes
  useEffect(() => {
    setDetailsMap(new Map());
    loadedUomsRef.current.clear();
  }, [inventoryId]);

  // =========================
  // ✅ UOM options per item (for UOM column select)
  // =========================
  const uomsByItemId = useMemo(() => {
    const map = new Map<string, ItemWithUomRow[]>();

    for (const r of detailsMap.values()) {
      if (!r?.itemId) continue;
      const list = map.get(r.itemId) ?? [];
      list.push(r);
      map.set(r.itemId, list);
    }

    for (const [itemId, list] of map.entries()) {
      const uniq = new Map<string, ItemWithUomRow>();
      for (const r of list) uniq.set(r.unitOfMeasure, r);

      const arr = Array.from(uniq.values());
      arr.sort((a, b) => Number(b.isPrimaryUOM) - Number(a.isPrimaryUOM));
      map.set(itemId, arr);
    }

    return map;
  }, [detailsMap]);

  const loadedUomsRef = useRef(new Set<string>());
  const uomsAbortRef = useRef<AbortController | null>(null);
  const [uomsLoading, setUomsLoading] = useState(false);

  const ensureItemUomsLoaded = async (itemType: ItemType, itemId: string) => {
    if (!inventoryId || !itemId) return;
    if (itemType === 'UndefinedItem') return;

    const key = `${inventoryId}|${itemType}|${itemId}`;
    if (loadedUomsRef.current.has(key)) return;

    loadedUomsRef.current.add(key);

    try {
      uomsAbortRef.current?.abort();
      uomsAbortRef.current = new AbortController();

      setUomsLoading(true);

      const resp = await fetchItemsWithUomLookup(
        {
          InventoryId: inventoryId,
          Scope: 1
        },
        {
          pageIndex: 1,
          pageSize: 3000,
          itemType,
          itemIds: [itemId]
        },
        uomsAbortRef.current.signal
      );

      const list: ItemWithUomRow[] = resp?.data?.data || [];
      if (!Array.isArray(list) || list.length === 0) return;

      setDetailsMap(prev => {
        const merged = new Map(prev);
        for (const r of list) merged.set(`${r.itemId}|${r.unitOfMeasure}`, r);
        return merged;
      });
    } catch (e: any) {
      if (e?.name !== 'CanceledError') {
        loadedUomsRef.current.delete(key);
        console.error(e);
      }
    } finally {
      setUomsLoading(false);
    }
  };

  // ✅ keep barcode input focused when inventory is selected
  useEffect(() => {
    setBarcodeError(null);
    if (!inventoryId) return;
    const h = window.setTimeout(() => barcodeInputRef.current?.focus(), 50);
    return () => window.clearTimeout(h);
  }, [inventoryId]);

  const pickBestRowForBarcode = (rows: ItemWithUomRow[]) => {
    if (!Array.isArray(rows) || rows.length === 0) return null;
    return rows.find(r => r?.isPrimaryUOM) || rows[0];
  };

  const addLineByBarcode = async (rawBarcode: string) => {
    const barcode = String(rawBarcode || '').trim();
    if (!barcode) return;

    setBarcodeError(null);

    if (!inventoryId) {
      setBarcodeError(i18n.language === 'en' ? 'Select inventory first.' : 'اختر المخزن أولاً.');
      barcodeInputRef.current?.focus();
      return;
    }

    // ✅ Cancel previous scan request
    barcodeAbortRef.current?.abort();
    barcodeAbortRef.current = new AbortController();

    setBarcodeLoading(true);
    try {
      // ✅ For PR: barcode scan targets inventory items by default
      const itemType: ItemType = DEFAULT_ITEM_TYPE;

      const resp = await fetchItemsWithUomLookup(
        {
          InventoryId: inventoryId,
          Scope: 1
        },
        {
          pageIndex: 1,
          pageSize: 30,
          itemType,
          barcodeEqual: barcode // ✅ مثل POLines
        } as any,
        barcodeAbortRef.current.signal
      );

      const list: ItemWithUomRow[] = resp?.data?.data || [];
      const picked = pickBestRowForBarcode(list);

      if (!picked?.itemId || !picked?.unitOfMeasure) {
        setBarcodeError(i18n.language === 'en' ? 'Barcode not found.' : 'لا يوجد صنف بهذا الباركود.');
        barcodeInputRef.current?.focus();
        return;
      }

      // ✅ store for display
      setDetailsMap(prev => {
        const m = new Map(prev);
        m.set(`${picked.itemId}|${picked.unitOfMeasure}`, picked);
        return m;
      });

      // ✅ preload all UOMs for the item (so UOM select is ready)
      ensureItemUomsLoaded(itemType, picked.itemId);

      // ✅ add or increment qty
      const lines = [...(values.transactionsLinesList || [])];
      const existingIndex = lines.findIndex(
        (l: any) =>
          String(l?.itemId || '') === String(picked.itemId) && String(l?.uom || '') === String(picked.unitOfMeasure)
      );

      if (existingIndex >= 0) {
        const current = { ...lines[existingIndex] };
        current.qty = Number(current.qty || 0) + 1;
        lines[existingIndex] = current;
        formik.setFieldValue('transactionsLinesList', lines);
      } else {
        const isEn = i18n.language === 'en';
        const desc = isEn ? picked.name || picked.name2 || '' : picked.name2 || picked.name || '';

        const newLine: any = {
          itemType,
          itemId: picked.itemId,
          lineNumber: lines.length + 1,
          uom: picked.unitOfMeasure,
          qty: 1,
          description: desc,
          id: null,
          inventoryId: inventoryId ?? ''
        };

        formik.setFieldValue('transactionsLinesList', [...lines, newLine]);
      }

      setBarcodeTerm('');
      barcodeInputRef.current?.focus();
    } catch (e: any) {
      if (e?.name !== 'CanceledError') {
        console.error(e);
        setBarcodeError(i18n.language === 'en' ? 'Failed to lookup barcode.' : 'تعذر البحث عن الباركود.');
      }
    } finally {
      setBarcodeLoading(false);
    }
  };

  // =========================
  // Line change
  // =========================
  const handleLineChange = (index: number, field: string, value: any) => {
    const updatedLines = [...(values.transactionsLinesList || [])];
    if (!updatedLines[index]) return;

    const currentLine = { ...updatedLines[index] };
    const currentItemType: ItemType = (currentLine.itemType || DEFAULT_ITEM_TYPE) as ItemType;

    // ✅ itemType
    if (field === 'itemType') {
      const nextType = (value || DEFAULT_ITEM_TYPE) as ItemType;

      if (nextType === 'UndefinedItem') {
        updatedLines[index] = {
          ...resetLineBase(currentLine),
          itemType: nextType,
          uom: EACH_UOM_ID
        };
      } else {
        updatedLines[index] = {
          ...resetLineBase(currentLine),
          itemType: nextType
        };
      }

      formik.setFieldValue('transactionsLinesList', updatedLines);
      return;
    }

    // ✅ clear item
    if (field === 'clearItem') {
      const newLine = {
        ...resetLineBase(currentLine),
        itemType: currentItemType
      };
      if (currentItemType === 'UndefinedItem') newLine.uom = EACH_UOM_ID;

      updatedLines[index] = newLine;
      formik.setFieldValue('transactionsLinesList', updatedLines);
      return;
    }

    // ✅ uom
    if (field === 'uom') {
      const itemId = currentLine.itemId;
      if (itemId && lineHasDuplicateItemUom(itemId, value, index)) {
        window?.alert?.(t('لا يمكن تكرار نفس الصنف بنفس الوحدة.'));
        return;
      }

      updatedLines[index] = { ...currentLine, uom: value };
      formik.setFieldValue('transactionsLinesList', updatedLines);
      return;
    }

    updatedLines[index] = { ...currentLine, [field]: value };
    formik.setFieldValue('transactionsLinesList', updatedLines);
  };

  // =========================
  // Add / Delete
  // =========================
  const handleAddLine = () => {
    const newLine = {
      itemType: DEFAULT_ITEM_TYPE,
      itemId: null,
      lineNumber: (values.transactionsLinesList?.length || 0) + 1,
      uom: '',
      qty: 1,
      description: '',
      id: null,
      inventoryId: inventoryId ?? ''
    };

    formik.setFieldValue('transactionsLinesList', [...(formik.values.transactionsLinesList || []), newLine]);
  };

  const handleDeleteLine = (index: number) => {
    const updatedLines = (values.transactionsLinesList || []).filter((_: any, i: number) => i !== index);
    formik?.setFieldValue('transactionsLinesList', updatedLines);
  };

  // =========================
  // ✅ Open picker for line (select item + uom)
  // =========================
  const openPickerForLine = async (lineIndex: number) => {
    const lines = values.transactionsLinesList || [];
    const line = lines[lineIndex];
    if (!line) return;

    const itemType: ItemType = (line.itemType || DEFAULT_ITEM_TYPE) as ItemType;

    if (!inventoryId) {
      window?.alert?.(t('يجب اختيار المخزن أولاً.'));
      return;
    }

    if (itemType === 'UndefinedItem') return;

    const picked = await pickItemUom({
      title: i18n.language === 'en' ? 'Pick Item & UOM' : 'اختيار صنف ووحدة',
      params: {
        InventoryId: inventoryId,
        Scope: 1
      },
      bodyDefaults: {
        categoryId: values.categoryId ?? undefined,
        itemType
      },
      pageSize: 10,
      searchMode: 'manual',
      initialSearchField: 'barcodeEqual',
      isDisabledRow: (r: any) => lineHasDuplicateItemUom(r.itemId, r.unitOfMeasure, lineIndex)
    });

    if (!picked) return;

    const row: any = picked.row;

    if (lineHasDuplicateItemUom(row.itemId, row.unitOfMeasure, lineIndex)) {
      window?.alert?.(t('لا يمكن تكرار نفس الصنف بنفس الوحدة.'));
      return;
    }

    // ✅ خزّن للعرض فوراً
    setDetailsMap(prev => {
      const m = new Map(prev);
      m.set(`${row.itemId}|${row.unitOfMeasure}`, row);
      return m;
    });

    const isEn = i18n.language === 'en';
    const desc = isEn ? row.name || row.name2 || '' : row.name2 || row.name || '';

    const updatedLines = [...lines];
    const currentLine = { ...updatedLines[lineIndex] };

    updatedLines[lineIndex] = {
      ...currentLine,
      itemType,
      itemId: row.itemId,
      uom: row.unitOfMeasure,
      description: desc,
      qty: Number(currentLine.qty || 1)
    };

    formik.setFieldValue('transactionsLinesList', updatedLines);

    // ✅ preload UOMs for select
    ensureItemUomsLoaded(itemType, row.itemId);
  };

  // =========================
  // Totals
  // =========================
  const totals = useMemo(() => {
    const qtyTotal = (values.transactionsLinesList || []).reduce((sum: number, l: any) => sum + Number(l.qty || 0), 0);
    return { qtyTotal };
  }, [values.transactionsLinesList]);

  // =========================
  // UI
  // =========================

  // console.log(values.transactionsLinesList);
  

  return (
    <Loading loading={false} error={null} Type='Dots'>
      <ItemUomPickerModal {...modalProps} />

      <div className='border-0'>
         <div className='card-header d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center gap-2'>
  <div className='d-flex align-items-center'>
    <i className='fas fa-clipboard-list fs-5 text-theme me-2'></i>

    <h6 className='mb-0 fw-semibold text-truncate' style={{ maxWidth: '100%' }}>
      {t('بنود طلب الشراء')}
      <span className='badge bg-theme rounded-pill ms-2'>{values.transactionsLinesList?.length || 0}</span>
    </h6>
  </div>

  <div className='d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-2'>
    {detailsLoading && isUpdate && (
      <div className='d-flex align-items-center'>
        <span className='spinner-border spinner-border-sm text-theme me-2'></span>
        <small className='text-muted'>{t('جاري تحميل التفاصيل...')}</small>
      </div>
    )}

    {/* ✅ Barcode Scan */}
    <div className='position-relative' style={{ width: '100%', maxWidth: 320 }}>
      <div className='input-group input-group-sm w-100'>
        <span className='input-group-text'>
          <i className='fas fa-barcode text-muted'></i>
        </span>

        <input
          ref={barcodeInputRef}
          value={barcodeTerm}
          onChange={e => {
            setBarcodeTerm(e.target.value);
            if (barcodeError) setBarcodeError(null);
          }}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              addLineByBarcode(barcodeTerm);
            }
            if (e.key === 'Escape') {
              setBarcodeTerm('');
              setBarcodeError(null);
            }
          }}
          className='form-control'
          disabled={!inventoryId || barcodeLoading}
          placeholder={t('امسح الباركود أو أدخل الرقم')}
          inputMode='numeric'
        />

        {barcodeLoading ? (
          <span className='input-group-text'>
            <span className='spinner-border spinner-border-sm text-theme' />
          </span>
        ) : (
          <button
            className='input-group-text'
            onClick={() => barcodeTerm && addLineByBarcode(barcodeTerm)}
            disabled={!barcodeTerm || barcodeLoading || !inventoryId}
            title={t('إضافة')}
          >
            <i className='fas fa-plus text-theme'></i>
          </button>
        )}
      </div>

      {/* ✅ على الجوال خليها تحت الحقل بشكل طبيعي (بدون absolute) */}
      {barcodeError && (
        <div className='mt-1'>
          <div className='alert alert-danger alert-sm py-1 mb-0 d-flex align-items-center'>
            <i className='fas fa-exclamation-circle me-2'></i>
            <small>{barcodeError}</small>
          </div>
        </div>
      )}
    </div>

    <button
      type='button'
      className='btn btn-theme btn-sm d-flex align-items-center justify-content-center px-3 w-100'
      onClick={handleAddLine}
      style={{ whiteSpace: 'nowrap' }}
    >
      <i className='fas fa-plus'></i>
      <span className='d-none d-sm-inline ms-2'>{t('بند جديد')}</span>
    </button>
  </div>
</div>
      

        {/* ✅ Summary strip */}
        <div className='card-body p-3'>
          <div className='bg-inverse bg-opacity-10 p-3 rounded-0'>
            <div className='d-flex flex-wrap gap-4 justify-content-between'>
              <div className='d-flex gap-2 align-items-center'>
                <span className='fw-bold'>{t('عدد البنود')}:</span>
                <span className='fw-bold'>{values.transactionsLinesList?.length || 0}</span>
              </div>
              <div className='d-flex gap-2 align-items-center'>
                <span className='fw-bold'>{t('إجمالي الكمية')}:</span>
                <span className='fw-bold text-warning'>{totals.qtyTotal}</span>
              </div>
              <div className='d-flex gap-2 align-items-center'>
                <span className='fw-bold'>{t('المخزن')}:</span>
                <span className='text-theme fw-bold'>{inventoryId ? t('محدد') : t('غير محدد')}</span>
              </div>
            </div>
          </div>
        </div>

        <div className='card-body p-0'>
          <div className='table-responsive' style={{ maxHeight: maxTableHeight, overflow: 'auto' }}>
            <table className='table table-hover mb-0' style={{ minWidth: '1300px' }}>
              <thead
                className='shadow fw-bold'
                style={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 100,
                  backdropFilter: 'blur(30px)'
                }}
              >
                <tr>
                  <th
                    className='text-center small shadow'
                    style={{
                      width: '50px',
                      minWidth: '50px',
                      position: 'sticky',
                      left: 0,
                      zIndex: 101
                    }}
                  >
                    #
                  </th>

                  <th className='text-center small' style={{ width: '120px', minWidth: '120px' }}>
                    {t('نوع الصنف')}
                  </th>

                  <th className='text-center small' style={{ width: '550px', minWidth: '550px' }}>
                    {t('الصنف / الباركود')}
                  </th>

                  <th className='text-center small' style={{ width: '120px', minWidth: '120px' }}>
                    {t('الوحدة')}
                  </th>

                  <th className='text-center small' style={{ width: '100px', minWidth: '100px' }}>
                    {t('الكمية')}
                  </th>

                  <th className='text-center small' style={{ width: '60px', minWidth: '60px' }}></th>
                </tr>
              </thead>

              <tbody>
                {(values.transactionsLinesList || []).length > 0 ? (
                  (values.transactionsLinesList || []).map((line: any, index: number) => {
                    const itemType: ItemType = (line.itemType || DEFAULT_ITEM_TYPE) as ItemType;

                    const isDuplicate =
                      itemType !== 'UndefinedItem' &&
                      line.itemId &&
                      line.uom &&
                      (values.transactionsLinesList || []).some(
                        (l: any, i: number) =>
                          i !== index &&
                          String(l?.itemId || '') === String(line.itemId) &&
                          String(l?.uom || '') === String(line.uom || '')
                      );

                    const disablePick = !inventoryId || itemType === 'UndefinedItem';

                    const info = getInfo(line);
                    const itemName = itemType === 'UndefinedItem' ? '' : (line.itemId ? getItemNameForLine(line) : '');
                    const barcode = info?.barcode || '';

                    const barcodeDisplay =
                      itemType === 'UndefinedItem'
                        ? '-'
                        : barcode ||
                          (detailsLoading ? (i18n.language === 'en' ? 'Loading...' : '...جاري التحميل') : '-');

                    const uomOptions =
                      itemType !== 'UndefinedItem' && line.itemId ? uomsByItemId.get(String(line.itemId)) || [] : [];

                    const uomDisplay =
                      itemType === 'UndefinedItem'
                        ? i18n.language === 'en'
                          ? 'Each'
                          : 'حبة'
                        : getUomNameForLine(line) ||
                          (detailsLoading
                            ? i18n.language === 'en'
                              ? 'Loading...'
                              : '...جاري التحميل'
                            : line.uom
                            ? `ID: ${line.uom}`
                            : '-');

                    return (
                      <tr key={index}>
                        <td className='text-center align-middle bg-body shadow' style={{ position: 'sticky', left: 0 }}>
                          <span className='badge bg-theme bg-opacity-80 fw-bold' style={{ fontSize: '0.85rem' }}>
                            {index + 1}
                          </span>
                        </td>

                        {/* ✅ itemType */}
                        <td className='align-middle'>
                          <select
                            className='form-select form-select-sm border-theme bg-body'
                            value={itemType || ''}
                            onChange={e => handleLineChange(index, 'itemType', e.target.value)}
                            style={{ width: '100%' }}
                            disabled={isUpdate && !!line.id}
                          >
                            <option value='InventoryItem'>{i18n.language === 'en' ? 'Inventory' : 'مخزني'}</option>
                            <option value='FixedAssetItem'>{i18n.language === 'en' ? 'Fixed Asset' : 'أصل'}</option>
                            <option value='ServiceItem'>{i18n.language === 'en' ? 'Service' : 'خدمي'}</option>
                            <option value='UndefinedItem'>{i18n.language === 'en' ? 'Undefined Item' : 'صنف غير معرف'}</option>
                          </select>
                        </td>

                        {/* ✅ Item + Barcode + Actions */}
                        <td className='align-middle'>
                          <div style={{ width: '100%' }}>
                            {itemType === 'UndefinedItem' ? (
                              <div className='p-2 border border-theme bg-body'>
                                <Form.Control
                                  className='form-control form-control-sm border-theme'
                                  as='textarea'
                                  rows={1}
                                  value={line.description || ''}
                                  onChange={e => handleLineChange(index, 'description', e.target.value)}
                                  style={{ overflow: 'hidden', height: 'auto' }}
                                  placeholder={i18n.language === 'en' ? 'Enter description...' : 'اكتب وصف الصنف...'}
                                />

                                <small className='text-muted d-block mt-2'>
                                  {t('الوحدة')}: <span className='fw-bold text-theme'>{uomDisplay}</span>
                                  <span className='mx-2'>•</span>
                                  {t('باركود')}: <span className='fw-bold'>-</span>
                                </small>
                              </div>
                            ) : (
                              <div className={`p-2 border ${isDuplicate ? 'border-danger' : 'border-theme'} bg-body`}>
                                <div className='d-flex align-items-start gap-2'>
                                  <div className='flex-grow-1' style={{ minWidth: 0 }}>
                                    {line.itemId ? (
                                      <>
                                        <span className='fw-bold text-truncate d-block'>
                                          {itemName ||
                                            (detailsLoading
                                              ? i18n.language === 'en'
                                                ? 'Loading...'
                                                : '...جاري التحميل'
                                              : `ID: ${line.itemId}`)}
                                        </span>

                                        <small className='text-muted d-block'>
                                          {t('باركود')}: <span className='fw-bold'>{barcodeDisplay}</span>
                                        </small>
                                      </>
                                    ) : (
                                      <span className='text-muted'>{t('اختر الصنف')}</span>
                                    )}

                                    {isDuplicate && (
                                      <small className='text-danger d-block mt-1'>
                                        <i className='fas fa-exclamation-triangle me-1'></i>
                                        {t('هذا الصنف مكرر مع نفس الوحدة')}
                                      </small>
                                    )}
                                  </div>

                                  <div className='d-flex gap-1'>
                                    <button
                                      type='button'
                                      className='btn btn-sm btn-theme rounded-0'
                                      onClick={() => openPickerForLine(index)}
                                      disabled={disablePick}
                                      title={
                                        !inventoryId
                                          ? t('يجب اختيار المخزن أولاً.')
                                          : itemType === 'UndefinedItem'
                                          ? t('غير متاح للصنف غير المعرف')
                                          : t('اختيار صنف ووحدة')
                                      }
                                    >
                                      <i className='fas fa-search me-1'></i>
                                      {line.itemId ? t('تغيير') : t('اختيار')}
                                    </button>

                                    {line.itemId && (
                                      <button
                                        type='button'
                                        className='btn btn-sm btn-outline-danger rounded-0'
                                        onClick={() => handleLineChange(index, 'clearItem', true)}
                                        title={t('مسح الصنف')}
                                        disabled={isUpdate && !!line.id}
                                      >
                                        <i className='fas fa-times'></i>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </td>

                        {/* ✅ UOM select column */}
                        <td className='align-middle'>
                          {itemType === 'UndefinedItem' ? (
                            <div className='form-control form-control-sm bg-secondary bg-opacity-10 border-theme text-center'>
                              {i18n.language === 'en' ? 'Each' : 'حبة'}
                            </div>
                          ) : (
                            <select
                              disabled={!line.itemId}
                              className={`form-select form-select-sm bg-body ${
                                !line.itemId ? 'bg-secondary bg-opacity-40' : ''
                              } ${isDuplicate ? 'border-danger' : 'border-theme'}`}
                              value={line.uom || ''}
                              onFocus={() => {
                                if (line.itemId) ensureItemUomsLoaded(itemType, String(line.itemId));
                              }}
                              onChange={e => handleLineChange(index, 'uom', e.target.value)}
                              style={{ width: '100%' }}
                            >
                              <option value=''>{i18n.language === 'ar' ? 'اختر الوحدة' : 'Select UOM'}</option>

                              {/* لو ما حملنا خيارات بعد: اعرض الحالية */}
                              {line.uom && uomOptions.length === 0 && <option value={line.uom}>{uomDisplay}</option>}

                              {uomOptions.map(u => {
                                const isEn = i18n.language === 'en';
                                const label =
                                  (isEn
                                    ? u.unitOfMeasureName || u.unitOfMeasureName2
                                    : u.unitOfMeasureName2 || u.unitOfMeasureName) || `ID: ${u.unitOfMeasure}`;

                                return (
                                  <option key={u.unitOfMeasure} value={u.unitOfMeasure}>
                                    {label}
                                  </option>
                                );
                              })}

                              {uomsLoading && line.itemId ? (
                                <option value={line.uom || ''} disabled>
                                  {i18n.language === 'en' ? 'Loading...' : '...جاري التحميل'}
                                </option>
                              ) : null}
                            </select>
                          )}
                        </td>

                        {/* ✅ qty */}
                        <td className='align-middle'>
                          <NumericFormat
                            name={`line-${index}-qty`}
                            value={line.qty}
                            thousandSeparator=','
                            decimalSeparator='.'
                            decimalScale={0}
                            allowNegative={false}
                            className='form-control form-control-sm border-theme text-center bg-body'
                            onValueChange={v => handleLineChange(index, 'qty', v.floatValue ?? 0)}
                            disabled={itemType !== 'UndefinedItem' && !line.itemId}
                            style={{ width: '100%' }}
                          />
                        </td>

                        {/* ✅ delete */}
                        <td className='align-middle text-center'>
                          <button
                            type='button'
                            className='btn btn-sm btn-danger rounded-0'
                            onClick={() => handleDeleteLine(index)}
                            title={t('Delete Line')}
                            style={{ width: '28px', height: '28px', padding: '0' }}
                          >
                            <i className='fas fa-trash text-white'></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={6} className='text-center py-4 text-muted'>
                      <i className='fa fa-inbox fa-2x mb-2'></i>
                      <br />
                      {t('لا توجد بنود مضافة')}
                      <br />
                      <button type='button' className='btn btn-theme mt-3' onClick={handleAddLine}>
                        <i className='fas fa-plus me-2'></i>
                        {t('إضافة أول بند')}
                      </button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className='card-footer d-flex justify-content-between align-items-center'>
          <div className='text-muted small'>
            <i className='fas fa-list me-1'></i>
            عرض {(values.transactionsLinesList || []).length} من {(values.transactionsLinesList || []).length} بند
          </div>
          <div className='text-theme fw-bold'>
            <i className='fas fa-calculator me-2'></i>
            {t('إجمالي الكمية')}: {totals.qtyTotal}
          </div>
        </div>
      </div>
    </Loading>
  );
};

export default PRLines;
